<div class="formgrid grid" *ngIf="datosCliente!=null">
    <div class="col-12 md:col-12">
        <div>
            <h4>Información del cliente</h4><hr/>
                        <div class="formgrid grid">
                            <div class="field col-12 md:col-6">
                                <label class="text-900 font-semibold">Nombres</label>
                                <input type="text"
                                       disabled="disabled"
                                       value="{{ datosCliente?.nombres == ''?'N/A': datosCliente?.nombres}}"
                                       class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            </div>
                            <div class="field col-12 md:col-6">
                                <label class="text-900 font-semibold">Apellidos</label>
                                <input type="text"
                                       disabled="disabled"
                                       value="{{ datosCliente?.apellidos == ''?'N/A': datosCliente?.apellidos }}"
                                       class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            </div>
                        </div>
                        <div class="formgrid grid">
                            <div class="field col-12 md:col-6">
                                <label class="text-900 font-semibold">Correo</label>
                                <input type="text"
                                       disabled="disabled"
                                       value="{{ datosCliente!.contactos[1].contacto == ''?'N/A':datosCliente!.contactos[1].contacto}}"
                                       class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            </div>
                            <div class="field col-12 md:col-6">
                                <label class="text-900 font-semibold">Teléfono</label>
                                <input type="text"
                                       disabled="disabled"
                                       value="{{ datosCliente!.contactos[0].contacto == ''?'N/A':(datosCliente!.contactos[0].contacto | phoneFormat)}}"
                                       class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            </div>
                        </div>
        </div>
        <br/>
    </div>
</div>


